import { EPostHogEventName } from "../const/const"
import { firePostHogEvent } from "../model/services/firePostHogEvent"

export function fireAnalyticsEvent(event: EPostHogEventName) {
    firePostHogEvent(event)
}
